import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ViewDataArchival from '../../modules/admin/components/DataArchival/ViewDataArchival';

const ViewDataArchivalPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>DataArchival.ViewDetails')} />

      <ViewDataArchival />
    </>
  );
};

export default ViewDataArchivalPage;
